import apiFetch from '../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/campaign/${dossierId}/approve`, method: 'PUT', body: null, token: token, lastAccessDate })
}
